import ResetPasswordView from '../../views/ResetPasswordView.vue';
import ForgetPasswordView from '../../views/ForgetPasswordView.vue';

export default [
  {
    path: '/reset-password/:resetToken',
    name: 'resetPassword',
    component: ResetPasswordView,
    meta: {
      hideHeader: true,
      hideInactivityTracker: true
    }
  },
  {
    path: '/forget-password',
    name: 'forgetPassword',
    component: ForgetPasswordView,
    meta: {
      hideHeader: true,
      hideInactivityTracker: true
    }
  }
];
